export default __webpack_public_path__ + "assets/24a5d6710f05a4bc080240ca3732e07c.jpeg";